/* Pappy CRO: free-shipping bar live updates + sticky mobile add to cart */
(function(){
  function fmt(cents, format){
    var v=(cents/100).toFixed(2); var whole=(cents%100===0)?String(cents/100):v;
    if(!format) return '$'+whole;
    return format.replace(/\{\{\s*amount_no_decimals\s*\}\}/,Math.round(cents/100)).replace(/\{\{\s*amount\s*\}\}/,v).replace(/\{\{\s*[a-z_]+\s*\}\}/,whole);
  }
  function paint(total){
    document.querySelectorAll('[data-pappy-ship-bar]').forEach(function(bar){
      var th=parseInt(bar.dataset.threshold,10)||0; if(!th) return;
      var rem=th-total, pct=Math.min(100,Math.max(0,total*100/th));
      var txt=bar.querySelector('[data-pappy-ship-text]'), fill=bar.querySelector('[data-pappy-ship-fill]');
      if(fill) fill.style.width=pct+'%';
      if(txt) txt.textContent = rem>0 ? bar.dataset.msgAway.replace('[amount]', fmt(rem, bar.dataset.moneyFormat)) : bar.dataset.msgDone;
    });
  }
  var t; function refresh(){ clearTimeout(t); t=setTimeout(function(){
    fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json()}).then(function(c){paint(c.total_price)}).catch(function(){});
  },250); }
  ['cart:updated','ajaxProduct:added','cart:open','drawerOpen'].forEach(function(e){document.addEventListener(e,refresh)});
  document.addEventListener('DOMContentLoaded',function(){
    document.querySelectorAll('[data-subtotal]').forEach(function(el){
      new MutationObserver(refresh).observe(el,{childList:true,characterData:true,subtree:true});
    });
    var drawer=document.getElementById('CartDrawer');
    if(drawer) new MutationObserver(refresh).observe(drawer,{attributes:true,attributeFilter:['class']});
    initSticky();
  });

  function initSticky(){
    var btn=document.querySelector('.product-single__form button[name="add"]');
    if(!btn || document.querySelector('.pappy-sticky-atc')) return;
    var titleEl=document.querySelector('.product-single__title');
    var bar=document.createElement('div'); bar.className='pappy-sticky-atc'; bar.setAttribute('aria-hidden','true');
    bar.innerHTML='<div class="pappy-sticky-atc__info"><div class="pappy-sticky-atc__title"></div><div class="pappy-sticky-atc__price"></div></div><button type="button" class="pappy-sticky-atc__btn" tabindex="-1"></button>';
    bar.querySelector('.pappy-sticky-atc__title').textContent=titleEl?titleEl.textContent.trim():document.title;
    var sbtn=bar.querySelector('.pappy-sticky-atc__btn');
    function sync(){
      var scope=btn.closest('.product-section, [data-section-type="product"], .page-content')||document; var p=scope.querySelector('[data-product-price]');
      bar.querySelector('.pappy-sticky-atc__price').textContent=p?p.textContent.trim():'';
      var label=btn.querySelector('[data-add-to-cart-text]'); sbtn.textContent=label?label.textContent.trim():'Add to cart';
      sbtn.disabled=btn.disabled;
    }
    sync(); new MutationObserver(sync).observe(btn,{attributes:true,childList:true,subtree:true,characterData:true});
    sbtn.addEventListener('click',function(){ if(!btn.disabled) btn.click(); });
    document.body.appendChild(bar);
    new IntersectionObserver(function(es){ es.forEach(function(e){
      var below=e.boundingClientRect.top<0; bar.classList.toggle('is-visible', !e.isIntersecting && below);
    }); }).observe(btn);
  }
})();
